import React, { useState, useEffect } from "react";
import axios from "axios";
import Banner from "./components/Banner/Index";
import Container from "./components/Container/Index";
import BusinessEnquiry from "./components/Forms/Enquiry";
import Title from './components/Title/Index'
import ImageTag from './components/ImageTag/Index'
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";
import GallerySlider from './components/Gallery/GallerySlider'

const Clients = () => {
  const [Data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/clients.php`);
        setData(response.data);
      } catch (err) {
        setError(err.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error) return <div>Error: {error}</div>;
  if (!Data) return null;

  const {
    clientData, homeBanners, clientGallery
  } = Data;


  return (
    <main>
      <Banner Data={homeBanners[0]} ImageHeight={'550'} ImageWidth={'1920'} positionText={'right-text'} />
      <Container _parentClass="Overview" containerClass={'position-relative float-end'}>
        <div className="col-12 float-start">
          <div className="col-lg-6 col-12 m-auto">
            <Title firstHeading={clientData.heading} secondHeading={clientData.title} subTitle={clientData.descp} _class={'text-lg-center text-start'} headingOne={true}/>
          </div>
        </div>
        <div className='col-lg-10 col-12 m-auto clientLogo'>
          <div className='row flex-center gap-3'>
            {clientData.clientLogo.map((logo, index) => (

              <div
                className='col-lg-2 col-sm-4 col-9 text-center flex-center p-lg-4 p-2 border bg-white logoSlide flex-wrap'
                key={index}
              >
                <ImageTag
                  ImagePath={logo.imagePath}
                  ImageAlt={logo.imageAlt}
                  ImageWidth={192}
                  ImageHeight={100}
                />
                <ImageTag
                  ImagePath={logo.supporting_doc}
                  ImageAlt={'Bottle Lebal Long Rider'}
                  ImageClass={'bottleLable'}
                  ImageWidth={192}
                  ImageHeight={250}
                />

              </div>
            ))}
          </div>
        </div>
      </Container>
      {clientGallery && <GallerySlider Data={clientGallery} />}
      <BusinessEnquiry />
    </main>
  )
}

export default Clients